// export const BASE_URL = "https://stage-be.tri-oakcrm.com/api";

// porduction url
export const BASE_URL = "https://prod-be.tri-oakcrm.com/api";
